module.exports = __webpack_public_path__ + "static/media/step_detail_career_dien_tu_mobile.e8d44a26.jpg";